export default "__VITE_ASSET__BTsr5zbf__"